<template>
  <div class="ai_box">
    <div class="par-pos">
      <vue-particles
        color="#ffffff"
        :particleOpacity="0.7"
        linesColor="#ffffff"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="5"
        :linesWidth="2"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
    </div>
    <div class="wrap" style="zoom:95%;padding-top: 3%;">
      <!-- <el-row>
          <el-col>
            <div class="grid-content">
                <el-image
                  min-height="300px"
                  :src="bannerImage"
                  fit="cover"></el-image>
            </div>
          </el-col>
        </el-row> -->
      <el-row>
        <el-col :span="12" :offset="6">
          <el-steps :active="activeStep">
            <el-step :title="$t('aiRecommendation.selfIntroduction')"></el-step>
            <el-step
              :title="$t('aiRecommendation.jobRecommendation')"
            ></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <el-row :class="activeStep == 1 ? 'block' : 'none'">
        <el-col>
          <el-card :body-style="{ padding: '0px' }" shadow="never" ref="recommendationCard">
            <div>
              <h4 style="font-size: 19px;">
                <span v-for="(char, index) in text" :key="index">{{
                  char
                }}</span>
              </h4>
              <el-form :model="inputForm" :rules="rules" ref="inputForm">
                <el-form-item prop="selfAssessment">
                  <el-input
                    type="textarea"
                    minlength="50"
                    maxlength="1000"
                    :show-word-limit="true"
                    :autosize="{ minRows: 3, maxRows: 20 }"
                    :placeholder="$t('aiRecommendation.pleaseInputContent')"
                    v-model="inputForm.selfAssessment"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <div class="bottom clearfix pull-right">
                    <el-button
                      type="primary"
                      class="button"
                      @click="submitForm('inputForm')"
                      round
                      >{{ $t("aiRecommendation.helpMeToRecommend") }}</el-button
                    >
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :class="activeStep == 2 ? 'block' : 'none'">
        <el-col>
          <div class="result_box" v-if="datalist">
             <!--  <h4>经过系统分析,您最适合的职业定位是:</h4>
          <h4>
              <span v-for="(char, index) in resultText" :key="index">{{
                char
              }}</span>
            </h4>  -->
            <!-- <h4>
              技术职能型(TF):对工作有专长和强烈兴趣，注重工作的专业化，对总经理工作缺乏热情，典型工作为技术主管和职能部门经理;您最适合工作的城市是:剑桥
            </h4> -->
            <h4>{{ $t("aiRecommendation.helpMeToRecommend") }}</h4>
            <div class="infinite-list">
              <div
                class="infinite-list-item item"
                v-for="(item, index) in datalist"
                :key="index"
                :class="item.type == 0 ? 'item_ad' : ''"
              >
                <div class="box">
                  <a :href="'#/jobApply?id=' + item.id + '&lang=' + lang" target="_blank">
                    <label class="type" :class="'type1'"></label>
                    <h3> {{ language == "zh" ? item.jobname : item.jobnameen }}</h3>
                    <div class="text">
                      <p v-html="language === 'zh' ? item.jobinfo : item.jobinfoens"></p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="ys_box" v-show="isLoaded">
              <div class="tit">{{ $t("aiRecommendation.zhiyeyoushi") }}</div>
              <div class="f-c">
                <div class="charts" id="charts"></div>
                <div class="flex1">
                  <ul class="slide_list">
                    <li>
                      <span>{{ $t("aiRecommendation.guanzhuren") }}</span>
                      <div class="slide2">
                        <label :style="{ width: value1 + '%' }">{{ value1 }}</label>
                      </div>
                    </li>
                    <li>
                      <span>{{ $t("aiRecommendation.guanzhuwu") }}</span>
                      <div class="slide2">
                        <label style="width:45.9%">{{ value2 }}</label>
                      </div>
                    </li>
                    <li>
                      <span>{{ $t("aiRecommendation.chouxiang") }}</span>
                      <div class="slide2">
                        <label style="width:54.9%">{{ value4 }}</label>
                      </div>
                    </li>
                    <li>
                      <span>{{ $t("aiRecommendation.juxiang") }}</span>
                      <div class="slide2">
                        <label style="width:54.9%">{{ value3 }}</label>
                      </div>
                    </li>
                  </ul>
                  <ul :class="language == 'zh'?'slide_list2':'slide_list2 en'">
                    <li>
                      <span>{{ $t("aiRecommendation.guanzhuren") }}</span>
                      <p>{{ $t("aiRecommendation.guanzhurenmiaoshu") }}</p>
                    </li>
                    <li>
                      <span>{{ $t("aiRecommendation.guanzhuwu") }}</span>
                      <p>{{ $t("aiRecommendation.guanzhuwumiaoshu") }}</p>
                    </li>
                    <li>
                      <span>{{ $t("aiRecommendation.juxiang") }}</span>
                      <p>{{ $t("aiRecommendation.juxiangmiaoshu") }}</p>
                    </li>
                    <li>
                      <span>{{ $t("aiRecommendation.chouxiang") }}</span>
                      <p>{{ $t("aiRecommendation.chouxiangmiaoshu") }}</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="des">
                <el-table
                  border
                  :data="tableData"
                  style="width: 100%"
                  :span-method="arraySpanMethod"
                  v-if="language == 'zh'"
                >
                  <el-table-column  width="40" label="职业优势" prop="item1"></el-table-column>
                  
                  <el-table-column  label="职业优势"  prop="item2"       width="100"    ></el-table-column>
                 
                  <el-table-column label="优势描述"  prop="item3"></el-table-column>
                  
                  <el-table-column  label="优势倾向度" width="230">
                    <template slot-scope="scope">
                      <div class="d_slide">
                        <p class="p_slide">
                          <label :style="'width:' + scope.row.item4 + '%'"></label>
                          <span :style="'left:' + scope.row.item4 + '%'">{{scope.row.item4}}</span>
                        </p>
                      </div>
                    </template>
                  </el-table-column>
                   
                </el-table>
                <el-table
                  border
                  :data="tableData"
                  style="width: 100%"
                  :span-method="arraySpanMethod"
                  v-if="language == 'en'"
                >
                  <el-table-column width="80" label="Career Strengths" prop="item11"></el-table-column>
                  
                  <el-table-column label="Career Strengths"  prop="item12"       width="150"    ></el-table-column>
                 
                  <el-table-column  label="Advantage Description"  prop="item13"></el-table-column>
                  
                   
                  <el-table-column   label="Advantage Tendency" width="230">
                    <template slot-scope="scope">
                      <div class="d_slide">
                        <p class="p_slide">
                          <label :style="'width:' + scope.row.item4 + '%'"></label>
                          <span :style="'left:' + scope.row.item4 + '%'">{{scope.row.item4}}</span>
                        </p>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="item"></div>
            <div class="bottom clearfix pull-center">
              <el-button
                icon="el-icon-refresh"
                class="button"
                @click="resetPage()"
                round
                >{{ $t("aiRecommendation.retry") }}</el-button
              >
              <el-button type="text" class="button" round
                ><el-link href="/#/jobList" type="primary">{{
                  $t("aiRecommendation.moreJobs")
                }}</el-link></el-button
              >
            </div>
            <br />
          </div>

          <div class="img_w200">
            <img  v-if="language == 'zh'" src="/img/newercode.a94ec0f1.jpg" alt="" />
            <img  v-if="language == 'en'" src="/img/newercodeen.976a3931.jpg" alt="" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
const bannerImage = require("../assets/img/banner2.jpg");
import * as echarts from "echarts";
export default {
  data() {
    return {
      value1:0,
      value2:0,
      value3:0,
      value4:0,
      isLoaded: false,
      bannerImage: bannerImage,
      activeStep: 1,
      language: "",
      fullscreenLoadingHandler: null,
      inputForm: {
        selfAssessment: "",
      },
      rules: {
        selfAssessment: {
          required: true,
          message: this.$t("aiRecommendation.pleaseInputContent"),
          min: 50,
          max: 1000,
          trigger: "blur",
        },
      },
      datalist: [],
      lang: this.$i18n.locale,
      text: "",
      resultText: "",
      apiResultText: "", 
      tableData: [
        {
          item1: "主要角色",
          item2: "艺术型",
          item3:
            "艺术感受能力强，对南美方面感知敏说，眼光独到，在事物、环境，现象中通常会有所感知，领悟",
          item4: "60",
          item11: "Primary Role",
          item12: "Artistic Type",
          item13: "Strong in feeling art and beauty, with a unique perspective on the details in things and surroundings.",
        },
        {
          item1: "主要角色",
          item2: "服务型",
          item3:
            "换位思考能力强，协调矛盾，避免冲突，促进人与人之间的和谐共处，有意识地为他人服务",
          item4: "55.64",
          item11: "Primary Role",
          item12: "Service Type",
          item13: "Skilled at viewing things from others' standpoints, solving conflicts, avoiding disputes, promoting harmony in relationships, and willingly helping others.",
        },
        {
          item1: "主要角色",
          item2: "人文型",
          item3:
            "人文感知能力强，关注人的精神生活和个人修炼，尊重人的主体地位和个性差异。对人性较为敏感",
          item4: "50.54",
          item11: "Primary Role",
          item12: "Humanities Type",
          item13: "Strong in understanding people, caring about inner life and self-growth, respecting differences, perceptive and sensitive to human nature.",
        },
        {
          item1: "辅助角色",
          item2: "交际型",
          item3:
            "破冰和人际互动能力强，不断扩大人际圈子，结交新朋友，擅长与他人保持良好的关系",
          item4: "49.76",
          item11: "Supporting Role",
          item12: "Interpersonal Type",
          item13: "Good at starting conversations and interacting, expanding social circles, making new friends, and maintaining good relationships with others.",
        },
        {
          item1: "辅助角色",
          item2: "操作型",
          item3:
            "技术操作能力强，注重实用，动作协调，在操作工具、器械方面有优势，耐心、独立地完成常规工作",
          item4: "43.51",
          item11: "Supporting Role",
          item12: "Operational Type",
          item13: "Focuses on skills, practice and coordination. Good at using tools and working alone.",
        },
        {
          item1: "辅助角色",
          item2: "事务型",
          item3:
            "事务落实能力强，有象理次序，讲究有始有终，处理事务耐心严谨，在工作上一般按照具体计划办事",
          item4: "50.54",
          item11: "Supporting Role",
          item12: "Administrative Type",
          item13: "Good at carrying out routine tasks, follows plans and sees projects through from start to finish.",
        },
        
        {
          item1: "次要角色",
          item2: "技能型",
          item3:
            "动手实践能力强，灵活多变，运用不同的方法来解决难题和提高技能，在自己的专业领域里精益求精",
          item4: "50.54",
          item11: "Secondary Role",
          item12: "Technical Type",
          item13: "Focuses on practical skills and problem-solving. Uses various methods to improve and master their expertise.",
        },
        {
          item1: "次要角色",
          item2: "影响型",
          item3:
            "影响说服能力强，无惧挑战，话语极具影响力，激励他人采取行动，善于让他人接受自己的想法",
          item4: "50.54",
          item11: "Secondary Role",
          item12: "Influential Type",
          item13: "Strong in influence, fearless of challenges, inspire others to take action.Skilled at getting others to accept one's ideas.",
        },
        {
          item1: "次要角色",
          item2: "开拓型",
          item3:
            "开拓进取能力强，愿意冒险，保护环境，热衷于追求并挑战具体目标，擅长抓住新机遇",
          item4: "50.54",
          item11: "Secondary Role",
          item12: "Pioneering Type",
          item13: "Good at exploring new ideas, willing to take risks, values protecting the environment,  eager to set and reach clear goals.",
        }, 
        {
          item1: "避免角色",
          item2: "发现型",
          item3:
            "创新思维能力强，富于幻想，见解新颖，热衷于探索科学技术，在未知领域中不断地寻求创新",
          item4: "50.54",
          item11: "Avoided Role",
          item12: "Innovative Type",
          item13: "Strong in creative thinking, imaginative with fresh ideas, loves exploring science and new fields.",
        },
        {
          item1: "避免角色",
          item2: "管控型",
          item3:
            "管控管理能力强，看重权力，善于对人员、资源进行严格管理，结果导向强烈，不为人情所动",
          item4: "50.54",
          item11: "Avoided Role",
          item12: "Control Type",
          item13: "Strong at managing people and resources, results-oriented, and unaffected by personal ties.",
        },
        {
          item1: "避免角色",
          item2: "规划型",
          item3:
            "战略规划能力强，把握重点，追求高效，分析项目的系统性和可行性，善于制定战略，规划项目",
          item4: "50.54",
          item11: "Avoided Role",
          item12: "Planning Type",
          item13: "Strong in strategy and planning, focuses on key points and efficiency, good at analyzing projects and making clear plans.",
        } 
      ],
    };
  },
  watch: {
    lang: function() {
      this.text = this.$t("aiRecommendation.message");
      this.resultText = this.$t("aiRecommendation.resultText");
      this.updateChartLanguage();
    },
    language2: function(a, b) {
      this.language = a;
      this.updateChartLanguage();
    },
  },
  components: {},
  created() {
    this.loading = false;
    this.language = this.$i18n.locale;
      
    
  },
  computed: {
    language2() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    document.addEventListener("mousemove", this.handleMouseMove);
    this.typeMessage(0);
    this.language = this.$i18n.locale;
    var chartDom = document.getElementById("charts");
    this.chart = echarts.init(chartDom);
    var option;
    option = {
      color: ["#67F9D8", "#FFE434", "#56A3F1", "#FF917C"],
      radar: [
        {
          indicator: [
            { 
              name: this.$t("aiRecommendation.guanzhuren"),
              max: 100,
              color: '#333'
            },
            { 
              name: this.$t("aiRecommendation.guanzhuwu"),
              max: 100,
              color: '#333'
            },
            { 
              name: this.$t("aiRecommendation.juxiang"),
              max: 100,
              color: '#333'
            },
            { 
              name: this.$t("aiRecommendation.chouxiang"),
              max: 100,
              color: '#333'
            },
          ],
          center: ["50%", "50%"],
          radius: 120,
          startAngle: 90,
          splitNumber: 4,
          shape: "circle",
          axisName: {
            formatter: (value, indicator) => {
              return `{a|${value}}`;
            },
            rich: {
              a: {
                color: '#333',
                fontSize: 14,
                fontWeight: 'bold',
                lineHeight: 10
              }
            },
            color: "#428BD4",
          },
          splitArea: {
            areaStyle: {
              color: ["#77EADF", "#26C3BE", "#64AFE9", "#428BD4"],
              shadowColor: "rgba(0, 0, 0, 0.2)",
              shadowBlur: 10,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(211, 253, 250, 0.8)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(211, 253, 250, 0.8)",
            },
          },
        },
      ],
      series: [
        {
          type: "radar",
          emphasis: {
            lineStyle: {
              width: 4,
            },
          },
          data: [
            {
              value: [this.value1 || 0, this.value2 || 0, this.value3 || 0, this.value4 || 0],
              name: this.$t('aiRecommendation.mainRole'),
            },
            {
              value: [0, 0, 0, 0],
              name: this.$t('aiRecommendation.comparison'),
              areaStyle: {
                color: "rgba(255, 228, 52, 0.6)",
              },
            },
          ],
        },
      ],
    };
    if (option) {
      this.chart.setOption(option);
    }
  },
  methods: {
    resetPage() {
    //  this.activeStep = 1;
      location.reload();
    },
    typeMessage(index) {
      let message = this.$t("aiRecommendation.message");
      if (index < message.length) {
        setTimeout(() => {
          this.text = message.substring(0, index + 1);
          this.typeMessage(index + 1);
        }, 20); // 每100毫秒显示一个字符
      }
    },
    typeResultText(index, completeCallback) {
      let resultMessage = this.apiResultText;
      if (index < resultMessage.length) {
        setTimeout(() => {
          this.resultText = resultMessage.substring(0, index + 1);
          this.typeResultText(index + 1, completeCallback);
        }, 20); // 每100毫秒显示一个字符
      } else {
        if (completeCallback) {
          setTimeout(completeCallback, 500);
        }
      }
    },
    openLoadingScreen() {
      if (this.$refs.recommendationCard) {
        this.fullscreenLoadingHandler = this.$loading({
          target: this.$refs.recommendationCard.$el,
          text: this.$t("aiRecommendation.dataIsLoading"),
        });
        setTimeout(() => {
          this.closeLoadingScreen();
        }, 16000);
      } else {
        console.error("recommendationCard ref not found");
      }
    },
    closeLoadingScreen() {
      if (this.fullscreenLoadingHandler) {
        this.fullscreenLoadingHandler.close();
        this.fullscreenLoadingHandler = null;
      }
    },
    handleMouseMove() {
      // 在这里处理逻辑，例如更新全局状态等
      this.lang = this.$i18n.locale;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handlebtnQuery();
        } else {
          return false;
        }
      });
    },
    handlebtnQuery() {
      this.openLoadingScreen();
      this.datalist = [];
        this.handleQuery();
    },
    handleQuery() {
      this.listLoading = true;
      this.datalist = [];
      console.log("1112222111111111");
      this.lang = this.$i18n.locale;
      const param = { inputstring: this.inputForm.selfAssessment };
      this.$http
        .post(
           "https://test3.uc-elink.co.uk/api/ucjobapply/GetCasesJSONByPageIdDes",
        //   "http://localhost:8002/api/ucjobapply/GetCasesJSONByPageIdDes",
          param,
          { "Content-Type": "application/x-www-form-urlencoded" }
        )
        .then((response) => {
          console.log("aaaaaaaaaaaaaaaaaaaa");
          console.log(response.data.jobtype);
          var queryList = response.data.joblist;
          console.log(queryList);
          console.log("cccccccccccccccccc");
       //   this.apiResultText = response.data.jobtype;
          this.activeStep = 2;
          this.typeResultText(0, () => {
            queryList.forEach((item) => {
              this.datalist.push(item);
            });
          });
        })
        .catch((error) => {
          this.$message.error(error);
          this.closeLoadingScreen();
        });

       // 读取分析数据tableData
       this.$http
        .post( 
           "https://test3.uc-elink.co.uk/api/ucjobapply/getPersonality",
      //  "http://localhost:8002/api/ucjobapply/getPersonality",
         param,
          { "Content-Type": "application/x-www-form-urlencoded" }
         )
        .then((response) => {
          console.log("2222222222222222222"); 
          console.log(response.data);    
         // for (let i = 0; i < 3; i++) {
              //  if (this.tableData[i].item2 === "艺术型") {
                  //jsonArray[i].item4 = "60.00"; // 新的评分
                  console.log("33333333333333333333333333");
               //   console.log(this.tableData[i].item4);
               //   console.log(response.data[0]);
                    console.log(JSON.stringify(response.data[0]["艺术型"]));
                    this.tableData[0].item4= JSON.stringify(response.data[0]["艺术型"]);
                    console.log(this.tableData[0]);
                    this.tableData[1].item4= JSON.stringify(response.data[1]["服务型"]);
                    this.tableData[2].item4= JSON.stringify(response.data[2]["人文型"]);
                    this.tableData[3].item4= JSON.stringify(response.data[3]["交际型"]);

                    this.tableData[4].item4= JSON.stringify(response.data[4]["操作型"]);
                    this.tableData[5].item4= JSON.stringify(response.data[5]["事务型"]);
                    this.tableData[6].item4= JSON.stringify(response.data[6]["技能型"]);
                    this.tableData[7].item4= JSON.stringify(response.data[7]["影响型"]);

                    this.tableData[8].item4= JSON.stringify(response.data[8]["开拓型"]);
                    this.tableData[9].item4= JSON.stringify(response.data[9]["发现型"]);
                    this.tableData[10].item4= JSON.stringify(response.data[10]["管控型"]);
                    this.tableData[11].item4= JSON.stringify(response.data[11]["规划型"]);
                    this.value1 = parseFloat(response.data[12]["关注人"]);
    this.value2 = parseFloat(response.data[13]["关注物"]);
    this.value3 = parseFloat(response.data[14]["具象"]);
    this.value4 = parseFloat(response.data[15]["抽象"]);
    
    // Update the chart with new data
    if (this.chart) {
      const option = this.chart.getOption();
      option.series[0].data[0].value = [this.value1, this.value2, this.value3, this.value4];
      this.chart.setOption(option);
    }
                    this.isLoaded = true;
                    this.closeLoadingScreen();
            // }
        //   } 
        })
        .catch((error) => {
          this.$message.error(error);
          this.closeLoadingScreen();
        });
    },

    arraySpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    updateChartLanguage() {
      if (this.chart) {
        const option = this.chart.getOption();
        option.radar[0].indicator = [
          { 
            name: this.$t("aiRecommendation.guanzhuren"),
            max: 100,
            color: '#333'
          },
          { 
            name: this.$t("aiRecommendation.guanzhuwu"),
            max: 100,
            color: '#333'
          },
          { 
            name: this.$t("aiRecommendation.juxiang"),
            max: 100,
            color: '#333'
          },
          { 
            name: this.$t("aiRecommendation.chouxiang"),
            max: 100,
            color: '#333'
          },
        ];
        this.chart.setOption(option);
      }
    },
  },
};
</script>
<style>
.bottom {
  margin-top: 13px;
  line-height: 12px;
}
.button {
  padding: 0;
  float: right;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.el-step__head {
  color: #303133 !important;
  border-color: #303133 !important;
}
.el-step__title {
  color: #303133 !important;
  font-weight: bold;
}
.el-row.block {
  display: block;
}
.el-row.none {
  display: none;
}
.ai_box{overflow: hidden;}
</style>
